import { render, staticRenderFns } from "./FooterItem.vue?vue&type=template&id=4ee4241a"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"
import style0 from "./FooterItem.vue?vue&type=style&index=0&id=4ee4241a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports